const react_api_key = "22396a605a938d2b660b590ee30d14bd";

export const api = {
  fetchTrending: `/trending/all/week?api_key=22396a605a938d2b660b590ee30d14bd&language=en-US`,
  fetchNetflixOriginals: `/discover/tv?api_key=22396a605a938d2b660b590ee30d14bd&with_networks=213`,
  fetchTopRated: `/movie/top_rated?api_key=22396a605a938d2b660b590ee30d14bd&language=en-US`,
  fetchActionMovies: `/discover/movie?api_key=22396a605a938d2b660b590ee30d14bd&with_genres=28`,
  fetchComedyMovies: `/discover/movie?api_key=22396a605a938d2b660b590ee30d14bd&with_genres=35`,
  fetchHorrorMovies: `/discover/movie?api_key=22396a605a938d2b660b590ee30d14bd&with_genres=27`,
  fetchDocumentries: `/discover/movie?api_key=22396a605a938d2b660b590ee30d14bd&with_genres=99`,
};

export const api_key = {
  react_api_Url: "https://api.themoviedb.org/3",
  react_api_key: "7a107780a1b571645808b28b67008035",
};
